import Link from "next/link"
import { useEffect, useState } from "react"

export default function Related({ title }) {

  const [entriesToRender, setEntriesToRender] = useState([])

  useEffect(() => {
    setEntriesToRender(sampleSize(entriesArr.filter(isDiferentFromRender), 3))
  }, [])

  const isDiferentFromRender = (entryTitle) => {
    return entryTitle !== title
  }

  const sampleSize = ([...arr], n = 1) => {
    let currentIndex = arr.length, randomIndex
    while (currentIndex != 0) {

      // Pick a remaining element...
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex--;

      // And swap it with the current element.
      [arr[currentIndex], arr[randomIndex]] = [
        arr[randomIndex], arr[currentIndex]];
    }
    return arr.slice(0, n)
  }

  const entriesArr = [
    {
      title: "Florescer",
      subTitle: "Fotografia Autoral",
      link: "/portfolio/fotografia-autoral/florescer",
    },
    {
      title: "Isolamento",
      subTitle: "Fotografia Autoral",
      link: "/portfolio/fotografia-autoral/isolamento",
    },
    {
      title: "Media",
      subTitle: "Fotografia Autoral",
      link: "/portfolio/fotografia-autoral/media",
    },
    {
      title: "Permanência",
      subTitle: "Fotografia Autoral",
      link: "/portfolio/fotografia-autoral/permanencia",
    },
    { title: "Retratos", subTitle: false, link: "/portfolio/retratos" },
    {
      title: "Fotografia Corporativa",
      subTitle: false,
      link: "/portfolio/fotografia-corporativa",
    },
    {
      title: "Documental de Família",
      subTitle: "Fotografia Documental",
      link: "/portfolio/fotografia-documental/documental-familia",
    },
  ]

  return (
    <div className="px-4 lg:px-0">
      <h2 className="uppercase font-josefin-sans text-white text-4xl mb-8 lg:mb-20">Não deixar de ver</h2>
      <div className="border-t border-l border-almost-white/50 grid grid-cols-1 lg:grid-cols-3">
        {entriesToRender.map((entry, idx) => {
          return (
            <div className="border-r border-b border-almost-white/50 flex flex-col justify-center items-center p-14" key={idx}>
              <p className="text-almost-white font-lato uppercase text-sm mb-4">{entry.subTitle}</p>
              <Link href={entry.link}>
                <a className="text-white text-center font-josefin-sans text-4xl">{entry.title}</a>
              </Link>
            </div>
          )
        })}
      </div>
    </div>
  )
}